import { render } from "./HeroSubsection.vue?vue&type=template&id=f515b6a2&ts=true"
import script from "./HeroSubsection.vue?vue&type=script&lang=ts"
export * from "./HeroSubsection.vue?vue&type=script&lang=ts"

import "./HeroSubsection.vue?vue&type=style&index=0&id=f515b6a2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__